import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isSoundCloudMediaUrl, isYouTubeMediaUrl, isBandcampMediaUrl } from "~/utils/media";

const MediaSourceIcon = ({ track }) => {
  if (!track.media_id) return null;
  const linkType = isSoundCloudMediaUrl(track)
    ? "soundcloud"
    : isYouTubeMediaUrl(track)
    ? "youtube"
    : isBandcampMediaUrl
    ? "bandcamp"
    : "unknown";

  // add dc promo tracks youtube playlist id
  const promoTracksPlaylistId = `PLUddSnkeiymQnsuMAfLzwPErsTFw4QkiN`;
  const externalUrl = isYouTubeMediaUrl(track) ? `${track.sc_url}&list=${promoTracksPlaylistId}` : track.sc_url;

  return (
    <span className="footer-track-media-icon">
      <a
        href={externalUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Open in new tab"
        onClick={() =>
          window.gtag("event", `click`, {
            totd_external: linkType,
            value: `${track.artist} - ${track.title}`,
          })
        }
      >
        {isSoundCloudMediaUrl(track) && <FontAwesomeIcon icon={["fab", "soundcloud"]} />}
        {isYouTubeMediaUrl(track) && <FontAwesomeIcon icon={["fab", "youtube"]} />}
        {isBandcampMediaUrl(track) && <FontAwesomeIcon icon={["fab", "bandcamp"]} />}
      </a>
    </span>
  );
};

MediaSourceIcon.propTypes = {
  track: PropTypes.object,
};

export default MediaSourceIcon;
